const TEMPLATE = `
<section class="diagnostic-process-content-description fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <p class="section-label">Як це працює</p>
            </div>
            <div class="col-md-6">
                <h3>
                    Проста та зрозуміла співпраця — від першого звернення до отримання результату
                </h3>
                <p>Ми створили зрозумілу й зручну систему взаємодії, у якій співпраця з лабораторією є комфортною, передбачуваною та ефективною для медичних закладів і лікарів. Від першого контакту до видачі результату кожен етап супроводжується чітко вибудованими процесами, персональною комунікацією та постійним контролем якості.</p>
            </div>
        </div>
        <div class="row" style="margin-bottom: 24px;">
            <div class="col-12">
                <div class="video-section" data-animate-child data-delay="400">
                    <div class="video-wrapper" data-content="youtube-video" data-page="about-work" data-attribute="video"
                         data-original-attribute="video">
                        <img src="/images/video/image.png" alt="Мікроскопія в BML" class="video-thumbnail">
                        <button class="play-button"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- ЗМІНЕНО: Унікальний ID для ізольованого акордеону -->
        <div class="accordion-cases" id="work-process-accordion" data-section="accordion" data-animate-child
             data-delay="800">

        </div>
    </div>
</section>
`;

class BmlAboutWorkProcess extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-work-process', BmlAboutWorkProcess);
